<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Group Sharing</b>
        <b-button
          v-show="hasGroups"
          v-if="isAllowedToSharePerson && hasMoreGroupsToShareWith"
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="toggleCreateSharePersonModal"
        >
          <span class="button-text">Share with</span>
        </b-button>
      </b-card-header>

      <!-- List groups -->
      <div v-if="sharePersonRecords.length > 0">
        <b-list-group v-for="sp in sharePersonRecords" :key="sp.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent="toggleUpdateSharePersonModal(sp.id)">
              {{ _.get(sp, 'sgroup.groupName', 'Unknown') }} <img :src="'/static/img/' + (sp.personShareStatus ? 'shareYes.png' : 'shareNo.png')" height="21" width="21">
            </a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="sharePersonRecords.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>{{ !hasGroups ? 'Your organization does not belong to any groups' : 'This record is not currently shared' }}</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- Share New -->
    <CreateSharePersonModal
      :person="person"
      :personId="personId"
      :personOrganizationOwner="personOrganizationOwner"
      :selectedGroup="selectedGroup"
    ></CreateSharePersonModal>

    <!-- View/Update Existing -->
    <UpdateSharePersonModal
      :person="person"
      :personId="personId"
      :personOrganizationOwner="personOrganizationOwner"
      :shareRecord="shareRecord"
      :selectedGroup="selectedGroup"
    ></UpdateSharePersonModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateSharePersonModal from '@/components/Share/CreateSharePersonModal'
import UpdateSharePersonModal from '@/components/Share/UpdateSharePersonModal'
import userPermission from '@/mixins/userPermission'

export default {
  name: 'share-person-list',
  mixins: [userPermission],
  props: {
    personId: Number,
    personOrganizationOwner: Number
  },
  components: {
    CreateSharePersonModal,
    UpdateSharePersonModal
  },
  data: function () {
    return {
      showCreateSharePersonModal: false,
      showUpdatePersonModal: false,
      selectedGroup: {},
      shareRecordId: 0
    }
  },
  computed: {
    ...mapGetters({
      person: 'getViewPerson',
      sharePersonRecords: 'sharePersonRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userCurrentContext: 'userCurrentContext' // Passing user context to determine if they have isOrgAdmin
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    },
    hasMoreGroupsToShareWith: function () {
      let condition = false
      let countGroups = this.getGroupsByOrg.length || 0
      let countShareRecords = this.sharePersonRecords.length || 0
      if (countGroups > countShareRecords) {
        condition = true
      }
      return condition
    },
    shareRecord: function () {
      return this.sharePersonRecords.find((r) => r.id === this.shareRecordId)
    }
  },
  watch: {
    personId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getSharePersonRecords', {
          sperson: newValue,
          populate: 'sgroup,sperson'
        })
      }
    }
  },
  methods: {
    toggleCreateSharePersonModal: function () {
      let countGroups = this.getGroupsByOrg.length
      let countShareRecords = this.sharePersonRecords.length
      if (countGroups === 1 && countShareRecords === 1) {
        // There is only 1 group to share with and there is already a sharing record, then move to the update share modal
        let shareRecordId = this.sharePersonRecords[0].id
        this.shareRecordId = shareRecordId
        this.$bvModal.show('update-share-person')
      } else {
        this.$bvModal.show('create-share-person')
      }
    },
    toggleUpdateSharePersonModal: function (shareRecordId) {
      this.shareRecordId = shareRecordId
      this.$bvModal.show('update-share-person')
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'sharePersonResponse' })
      this.$store.commit('RESET_SHARE_PERSON_RECORDS')
    }
  },
  beforeDestroy () {
    this.resetAll()
  },
  created () {
    this.selectedGroup = this.$store.getters.userCurrentContext.group
    if (this.personId && _.isInteger(this.personId)) {
      this.$store.dispatch('getSharePersonRecords', {
        sperson: this.personId,
        populate: 'sgroup,sperson'
      })
      this.$store.dispatch('getGroupsByOrg', { id: this.personOrganizationOwner })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Person/SharePersonList.vue